import { IDevolutionDeposit } from "@/types/devolution-deposit";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";


const API_URL = `${import.meta.env.VITE_API_URL}/devolution-deposit`;
const makeRequestDebounced = createDebounce(makeRequest, 200);


export async function createReturnOfDeposit(
  data: Partial<IDevolutionDeposit>
): Promise<ApiResponseType<IDevolutionDeposit>> {
  const url = `${API_URL}/`;
  const options: RequestInit = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const result = (await makeRequestDebounced(
    url,
    options
  )) as ApiResponseType<IDevolutionDeposit>;

  return result;
}


export async function getAllReturnOfDeposits({
  page = 1,
  itemsPerPage = 10,
  orderBy = "-createdAt",
  search = "",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    orderBy: orderBy,
  });

  search && params.append("search", search);

  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<IDevolutionDeposit[]> & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}


export async function updateReturnOfDeposit(renterId: string, pathFile: string) {
  const url = `${API_URL}/${renterId}`;

  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ file: pathFile }),
  };

  const result = (await makeRequestDebounced(url, options)) as Promise<ApiResponseType<IDevolutionDeposit>>;

  return result;
}

